import React, { useState } from 'react';
// import {operator} from '../components/affiliate';

function Todo({todo, index}) {
    return (
           
            <li class="card">
              <img src={todo.img} className="card-img-top" alt="..." />
              <div class="card-body">
                  <p className="card__price">{todo.pris}</p><span className="card__ordPrice">{todo.ordpris}</span>
                <h3 class="card__title">{todo.prodnamn}</h3>
                <p className="card__brodtext">{todo.text}</p>
                <a href={todo.recUrl} className="card__link">Läs recension</a>
                <a href={todo.buttonUrl} class="btn btn-warning" target="_blank" rel="noopener noreferrer">Köp nu</a>
              </div>
            </li>  
    )
}

function App() {
    // const namn = {operator};
    // console.log(namn.operator[0]);
    const [todos, setTodos] = useState([
        {
            img: '/vitatander-beconfident.jpg',
            pris: '599:-',
            ordpris: '799:-',
            prodnamn: 'Premium X3 Kit',
            text: 'Två olika tandbleknings geler, samt Tooth gloss.',
            recUrl: '/beconfident',
            buttonUrl: 'https://www.beconfident.se/tandblekning/vara-startkit/premium-kit?trackID=67035344&utm_source=adrecord&utm_medium=affiliate&utm_campaign=adrecord'
        },
        {
            img: '/vitatander-dentaworks.jpg',
            pris: '598:-',
            ordpris: '898:-',
            prodnamn: 'Dentaworks Plus',
            text: 'Gel, skenor och penna för tandblekning hemma.',
            recUrl: '/dentaworks',
            buttonUrl: 'https://www.tandblekning.com/dentaworks-plus-med-tandblekningspenna?roi=294&silent=true&utm_campaign=Adtraction%20CPO&at_gd=25A43DA673616BC548A84C3E6B5279CCBD5A1C2A'
        },
        {
            img: '/loanlogos/dentway.jpg',
            pris: '495:-',
            ordpris: '895:-',
            prodnamn: 'Dentway Starter Kit',
            text: 'Levereras med 2 stycken formbara tandskenor, blekningsgel 9ml.',
            recUrl: '/dentway',
            buttonUrl: 'https://www.dentway.se/sv/artiklar/dentway-starter-kit-regular.html?osadcampaign=adtraction&cn=at_gd&cv=25A43DA673616BC548A84C3E6B5279CCBD5A1C2A&cma=45&at_gd=25A43DA673616BC548A84C3E6B5279CCBD5A1C2A'
        }
    ])

    return (
            <ul class="card-show">
                {todos.map((todo, index) => (
                <Todo key={index} index={index} todo={todo} /> 
                ))}
            </ul>
    )

}

export default App;